import React from 'react';

export interface TabScrollContext {
  canOverscroll: boolean;
  offset: number;
  setOffset(offset: number): void;
}
const ScrollContext = React.createContext<TabScrollContext>({
  canOverscroll: false,
  offset: 0,
  setOffset: () => undefined
});

export default ScrollContext;
